import { FunctionComponent } from 'react';
import { SUBIMainModal } from 'widgets/auth/signUpByInvitation/_MainModal';

export const SignUpByInvitation: FunctionComponent = () => {
	return <SUBIMainModal />;
};
